import { FC } from 'react';

import { UserRoles } from 'app/constants/user';
import { useAuthState } from 'app/state/AuthContext/hooks';

import ExternalUserCompanyJumper from './ExternalUserCompanyJumper';
import InternalUserCompanyJumper from './InternalUserCompanyJumper';

// Component Definition
const CompanyJumper: FC = () => {
  const { authRoles } = useAuthState();
  const userIsInternal = authRoles.includes(UserRoles.AppManager) || authRoles.includes(UserRoles.TriumphInternal);

  return userIsInternal ? (<InternalUserCompanyJumper />) : (<ExternalUserCompanyJumper />);
};

export default CompanyJumper;
